import "./PageHeader.scss";
import {CmsPage, CmsSection} from "@lib/Cms/CmsModels";

interface PageHeaderProps {
    cms?: Partial<CmsSection> | Partial<CmsPage>;
}

const PageHeader = ({cms}: PageHeaderProps) => {

    if ( !cms ) return null;

    return (
        <div className={"page-header"}>
            <div className="container">
                <h1 className="page-header__title tp-2xl">
                    {!!cms.title && cms.title}
                    {!!cms.options?.highlightTitle && cms.options.highlightTitle &&
                        <span className="page-header__title-highlight">{cms.options.highlightTitle}</span>
                    }
                </h1>
                {cms.subTitle &&
                    <h2 className="page-header__subtitle tp-l light" dangerouslySetInnerHTML={{__html: cms.subTitle}}/>}
                {cms.text &&
                    <p className="page-header__description tp-m light" dangerouslySetInnerHTML={{__html: cms.text}}/>}
            </div>
        </div>
    );

}

export default PageHeader;